import DelayRangeFilter from 'components/Billing/DelayRangeFilter';
import { buildAlertIdOverride } from 'components/Billing/alertAction';
import SummaryCards from 'components/Billing/SummaryCards';
import { buildBillingColumns } from 'components/Billing/columns';
import { buildHistoryOverride } from 'components/Billing/historyAction';
import { buildRenegotiationOverride } from 'components/Billing/renegotiationTag';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import useBillingList from 'hooks/useBillingList';
import { useContext, useMemo } from 'react';
import { BILLING_QUERIES, buildCards } from 'utils/billing';

// Primeiro degrau da esteira: 1 a 30 dias de atraso. O recorte vem da query
// (BILLING_QUERIES.cobranca) — o front nao reclassifica nada.
export default function BillingCobranca() {
  const { user, setModal } = useContext(CoreContext);
  const {
    loading,
    visibleRows,
    indicators,
    delayFrom,
    setDelayFrom,
    delayTo,
    setDelayTo,
    clearDelay,
    criticalOnly,
    toggleCritical,
    reload,
  } = useBillingList({ query: BILLING_QUERIES.cobranca });

  const columns = useMemo(
    () =>
      buildBillingColumns(
        [
          'id',
          'contrato',
          'data_emissao',
          'banco',
          'distributor',
          'integrator',
          'customer',
          'telefone',
          'parcela',
          'valor_parcelas',
          'data_vencimento',
          'dias_atraso',
          'ultima_tentativa',
          'historico',
        ],
        {
          user,
          overrides: {
            ...buildHistoryOverride({ setModal, reload }),
            ...buildAlertIdOverride({ setModal, reload }),
            ...buildRenegotiationOverride(),
          },
        }
      ),
    [user, setModal, reload]
  );

  const cards = buildCards(indicators, {
    onToggleCritical: toggleCritical,
    criticalActive: criticalOnly,
  });

  return (
    <ContainerAuthenticated>
      <TableWrapper
        title="Cobrança"
        search
        filters={
          <DelayRangeFilter
            from={delayFrom}
            to={delayTo}
            onChangeFrom={setDelayFrom}
            onChangeTo={setDelayTo}
            onClear={clearDelay}
          />
        }
      >
        <SummaryCards cards={cards} />
        <BasicTable
          loading={loading}
          columns={columns}
          rows={visibleRows}
          // Uma linha por contrato; as parcelas vencidas saem no expandir.
          groupBy="id"
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
